<template>
  <div>
    <mall-header ></mall-header>
    <div class="guide-content" ></div>
    <div style=" overflow-x: auto; min-width: 1200px;    width: 1200px;margin: 0 auto;">
    <nav-Menu></nav-Menu>
    <div class="order-div">
        <span class="order-div-order" >订单详情</span>
        <span class="order-div-break" @click="openOrderList" >返回上一级</span>
        <span class="order-div-line" ></span>
        <div>
            <span class="order-div-time" >订单编号： <span style="    color: #333333;">{{orderData.orderNo}}</span></span>
            <span class="order-div-orderNo" >下单时间：<span style="    color: #333333;">{{orderData.createTime}}</span></span>
        </div>

        <div class="order-div-pay" >
            <span class="order-pay-statuts-font" >订单状态：</span>
            <span class="order-pay-statuts-1" v-if="orderData.orderStatus ==1">{{orderData.statusName}}</span>
            <span class="order-pay-statuts-2" v-if="orderData.orderStatus ==2">{{orderData.statusName}}</span>
            <span class="order-pay-statuts-3" v-if="orderData.orderStatus ==3">{{orderData.statusName}}</span>
            <span class="order-waitpay-font" v-if="orderData.orderStatus ==1">应付金额：</span>
            <span class="order-waitpay-money" v-if="orderData.orderStatus ==1">￥{{orderData.totalAmount}}</span>

            <el-button span v-if="orderData.orderStatus !=1" class="order-button-again"  @click="againOrder(orderData.id)" >再次购买</el-button>
            <span v-if="orderData.orderStatus ==2" style="    display: inline-block;
                  vertical-align: top;
                  margin-left: -180px;
                  margin-top: 65px;">感谢您的购买，您的成交时间：{{orderData.updateTime}} </span>
            <span v-if="orderData.orderStatus ==3" class="order-canle-time" >您的取消时间：{{orderData.updateTime}}</span>
            <div v-if="orderData.orderStatus ==1">
              <img src="../../static/images/时间.png" class="order-waitpay-img"  />
              <span class="order-waitpay-time" >{{orderData.countDownTime}}</span>
              <span class="order-canle-font" >内未付款，将自动取消订单</span>
            </div>
            <div style="    float: right;" v-if="orderData.orderStatus ==1">

              <el-button class="order-gopay-button" @click="toPay()">去付款</el-button>
               <el-button class="order-canle-button" @click="canlOrder" >取消订单</el-button>
            </div>
        </div>
        <div style="float: left;">
            <span class="order-shopInfo-font" >商品信息</span>
            <table class="order-shopInfo-table"   v-loading.fullscreen.lock="fullscreenLoading">
              <tr class="order-shopInfo-tr">

                <td width="600px">商品</td>
                <td width="200px">单价</td>
                <td width="200px">数量</td>
                <td width="200px">小计</td>
              </tr>
              <tr class="order-shopInfo-content-tr" v-for="(datas, i) in orderData.orderDetails" :key="i" >
                <td style="    float: left;margin: 20px;cursor: pointer;">
                  <span >
                    <img :src="datas.itemImgUrl" @click="openGoodsDetails(datas.serviceItemId)" style="width: 68px;height: 68px;cursor: pointer; "/>
                  </span>
                  <el-tooltip placement="right"  :open-delay="500"  :disabled="isTips" :content='datas.serviceItemName' >
                    <!-- <span  class="orderList-table-td-font" @mouseenter="showTips3($event)"  @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)">{{datas.orderDetails[0].serviceItemName}}</span> -->
                  <!-- <span class="cart-span-productName" @mouseenter="showTips($event)"  @click="openDetails(scope.row)">{{scope.row.serviceItem.name}}</span> -->
                  <span class="order-shopInfo-name" @mouseenter="tipsFun($event)"  @click="openGoodsDetails(datas.serviceItemId)" >{{datas.serviceItemName}}</span>
                  </el-tooltip>
                </td>
                <td style="    text-align: center;">￥{{datas.unitPrice}}</td>
                <td style="    text-align: center;">{{datas.quantity}}</td>
                <td class="order-shopInfo-amount" >￥{{datas.amount}}</td>
              </tr>
            </table>
        </div>
        <div style="float: left;width:980px">
          <div class="order-shopInfo-payType">
               <span  >支付方式</span>
          </div>
          <div class="order-shopInfo-actionType" >
              <span >活动类型：<span style="color: #333;">{{orderData.typeName}}</span></span>
              <span v-if="orderData.orderStatus ==2 && orderData.type ==1" style="    display: block;argin-top: 5px;">支付方式：<span style="color: #333;">微信支付</span></span>
              <span v-if="orderData.orderStatus ==2 && orderData.type ==2" style="    display: block; margin-top: 5px;">支付方式：<span style="color: #333;">支付宝支付</span></span>
              <span v-if="orderData.orderStatus ==2" style="margin-top: 5px; display: block;">支付时间：<span style="color: #333;">{{orderData.updateTime}}</span></span>
          </div>
        </div>
        <div>
          <div class="order-total-div" >
              <span class="order-total-font" >商品总价：<span style="color: #333;">￥{{orderData.totalAmount}}</span></span>
              <span class="order-total-num" >商品件数：</span>
              <span style="    float: right;margin-top: -20px;    color: #333;">{{totalQuantity}} 件</span>
          </div>
          <div class="order-total-money" >
              <span class="order-total-money-font" >实收金额：</span>
              <span class="order-total-totalAmount" >￥{{orderData.totalAmount}}</span>
          </div>
        </div>
            <el-backtop   style="right: initial;bottom: 40px;" >
              <div
                style="
                  height: 100%;
                  width: 100%;
                  box-shadow: 0 0 6px rgba(0,0,0, .12);
                  text-align: center;
                  line-height: 40px;
                  color: #1989fa; ">
                <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
              </div>
            </el-backtop>
    </div>
    </div>
     <div style="clear: both;height: 20px;">
      </div>
      <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import http from '../api/public'
import axios from 'axios'
import $ from 'jquery'
  export default {
    data () {
      return {
        orderData:[],
        activeName: 'first',
        totalQuantity:0,
        isTips:true,
        afterEqual:'',
        fullscreenLoading: true,
        goodDetailsId:"",
        dayDate : 60*60*24
      }
    },
    mounted() {
       //订单详情信息
      this.getOrderDetials();
    },
    methods: {
      //订单详情信息
      getOrderDetials() {
        let afterUrl =  window.location.hash.substring(1);
        if(afterUrl){
            let str = afterUrl.indexOf('=')+1
            this.afterEqual = afterUrl.substring(str).toUpperCase();
        }else{
            this.afterEqual = this.$route.query.orderId
        }
        axios.get('/mallApi/mall/order/queryById?id='+this.afterEqual,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          this.fullscreenLoading= false;
           if(res.success) {
            this.orderData = res.result;
            this.orderData.totalAmount  = http.changeUnitPrice(this.orderData.totalAmount);
            this.orderData.orderDetails.forEach(da => {
              da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
              da.unitPrice = http.changeUnitPrice(da.unitPrice);
              da.amount = http.changeUnitPrice( da.amount);
              //console.log( da.unitPrice);
            });
            this.statusName()
            this.typeName()
            this.timeArray()
            this.getOrderQuantity()
          }else{
            if(res.code == 401) {
              http.setLocalStorge();
              this.$router.push({path: '/login'});
            }else{
              this.$message(res.message);
            }
          }

        });
      },
      //返回上一级跳转至订单列表
     openOrderList(){
         this.$router.push({ path:'/orderList' })
     },
     tipsFun(obj){
        let off = obj.target.offsetHeight;
        let  sHeight = obj.currentTarget.scrollHeight;
        sHeight > off? this.isTips = false : this.isTips = true;
      },
    getOrderQuantity(){
         //this.$router.push({ path:'/OrderList' })
         let  data = this.orderData;
         for(let i=0;i<data.orderDetails.length;i++){
            this.totalQuantity+=data.orderDetails[i].quantity
         }

     },
     //待支付倒计时
     timeArray(){
        if(this.orderData.orderStatus == "1"){
          this.orderData.countDownTime = "";
          this.countDown();
        }
     },
      //再次购买
      // againOrder(value){
      //   debugger
      //     //this.$router.push({path: '/orderconfirm', query: {"orderId":value}})
      // },
      againOrder () {
        var tempData  = this.orderData;
        var listIds =[];
        tempData.orderDetails.forEach(da => {
            listIds.push( {"quantity": da.quantity ,"serviceItemId": da.serviceItemId});
        });
          axios.defaults.headers ={
            "content-type": "application/json",
            "token": localStorage.getItem("Authorization")
          }
          axios.post('/mallApi/mall/order/createByShopCarts', listIds).then((res) => {
            res = res.data;
            if(res.success){
                this.$router.push({path: '/orderconfirm', query: {"orderId":res.result.id}})
            }else {
              if(res.code == 401 ||  res.code == 403 || res.code == 400) {
                  console.log('请登录');
                  http.setLocalStorge();
                  this.$router.push({path: '/login?path='+this.$route.fullPath});
              }else{
                this.$message({
                    showClose: true,
                    message: '操作失败！',
                    type: 'error'
                  });
              }
            }
          });
      },
      countDown() {
        let that = this;
        let item = that.orderData;
        that.orderData.countDownFun = setInterval(() => {
          if (that.countDownFun(item.countDownTime) == "倒计时结束") {
            clearInterval(that.orderData.countDownFn); //清除定时器
          } else {
            item.countDownTime = that.countDownFun(item.createTime);
            that.$set(
              that.orderData,
              item.countDownTime,
              that.countDownFun(item.createTime)
            );
          }
        }, 1000);
      },
      countDownFun(time) {
          let startTime = new Date().getTime()/1000; //当前时间
          let end = new Date(this.orderData.createTime).getTime()/1000; //结束时间
          let endDate  = this.dayDate+end
          let result = parseInt(endDate - startTime); //计算出豪秒
          let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
          let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
          let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
          let s = parseInt(result % 60);
          let re = "剩余";
          if (result <= 0) {
            return "倒计时结束"
          }else{

            if (h < 10) {
              h = "0" + h;
            }
            if (s < 10) {
              s = "0" + s;
            }
            if(d >0 ){
              re += d+"天"
            }
            if(h>0){
              re += h+"时"
            }
            if(m>0){
              re += m +"分"
            }
            if(s>0){
              re += s +"秒"
            }
            return  re;
          }
      },
        handleClick(tab, event) {
          console.log(tab, event);
        },
        //订单状态显示转换
        statusName(){
          switch(this.orderData.orderStatus) {
            case "1":
                this.orderData.statusName = "等待付款"
                break;
            case "2":
                this.orderData.statusName = "交易完成"
                break;
            case "3":
                this.orderData.statusName = "交易关闭"
                break;
            default:
                this.orderData.statusName=""
                break;
          }
        },
        //订单活动类型显示转换
        typeName(){
          switch(this.orderData.type) {
            case "1":
                this.orderData.typeName = "线下购买"
                break;
            case "2":
                this.orderData.typeName = "在线充值"
                break;
            case "3":
                this.orderData.typeName = "活动赠送"
                break;
            case "4":
                this.orderData.typeName="消费返点"
                break;
            default:
                this.orderData.typeName="消费返点"
                break;
          }
      },
      //订单详情待支付订单的支付
      toPay(item) {
         this.$router.push({path: '/orderconfirm', query: {"orderId":this.orderData.id}})
      },
      //查看商品详情
      openGoodsDetails(id){
        window.open("#/GoodsDetails?id="+id);
     },
      //取消订单
      cancelOrderRquest(value){
         //axios.defaults.headers.put['mall-api-token'] = localStorage.getItem('Authorization');
            axios.put('/mallApi/mall/order/edit', {
                  'id': value,
                  'orderStatus':"3"
                },{headers:{"token": localStorage.getItem("Authorization")}}
              ).then(res => {

                 res = res.data;
                  if(res.success){
                    this.getOrderDetials();
                  }else {
                    if(res.code == 401|| res.code == 400) {
                     http.setLocalStorge();
                      this.$router.push({path: '/login'});
                    }else{
                      this.$message(res.message);
                    }
                    //console.log('请登录');
                  }
            })
      },
      //取消订单
     canlOrder(){
        let _than=this;
        this.$confirm('您确定要取消订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          _than.cancelOrderRquest(_than.orderData.id)
        });
     }
    },
    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      http
    }
  }
</script>
<style lang="scss" scoped>
  @import "../assets/style/mixin";
table[data-v-68e7f268], table tr th[data-v-68e7f268], table tr td[data-v-68e7f268] {
     border: 0px solid #EEEEEE;
}
  .order-div{
    width: 980px;
    min-width: 980px;
    margin-bottom: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    overflow: auto;
    margin: 0 auto;
    float: left;
    margin-top: -360px;
    margin-left: 220px;
  }
  .order-div div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
  .order-div-order{
    height: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    float: left;
    margin-left: 29px;
    margin-top: 22px;
  }
  .order-div-break{
    float: right;
    margin-right: 30px;
    margin-top: 22px;
    width: 70px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #287EFF;
    line-height: 20px;
    cursor: pointer;
  }
  .order-div-break:hover{text-decoration: underline;border-bottom:2px; color:#287EFF }
  .order-div-line{
    width: 982px;
    border-bottom: 1px solid #EEEEEE;
    height: 1px;
    position: absolute;
    margin-top: 60px;
    margin-left: -95px
  }
  .order-div-time{
    margin-left: -65px;
    position: absolute;
    margin-top: 88px;
  }
  .order-div-orderNo{
    margin-left: 175px;
    position: absolute;
    margin-top: 88px;
  }
  .order-div-pay{
    width: 920px;
    height: 108px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(238, 238, 238);
    float: left;
    margin-top: 105px;
    margin-left: 30px;
  }
  .order-pay-statuts-font{
    display: inline-block;
    vertical-align: top;
    margin: 30px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
  }
  .order-pay-statuts-1{
    display: inline-block;
    vertical-align: top;
    margin-top: 30px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FF620E;
    line-height: 20px;
    margin-left: -30px;
  }
  .order-pay-statuts-2{
    display: inline-block;
    vertical-align: top;
    margin-top: 30px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4CAF50;
    line-height: 20px;
    margin-left: -37px;
  }
  .order-pay-statuts-3{
    display: inline-block;
    vertical-align: top;
    margin-top: 30px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    margin-left: -35px;
  }
  .order-waitpay-font{
    height: 20px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    vertical-align: top;
    margin-top: 30px;
    position: absolute;
    margin-left: 30px;
  }

  .order-waitpay-money{
    height: 20px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FF620E;
    line-height: 20px;
    margin-top: 32px;
    position: absolute;
    margin-left: 120px;
  }
  .order-button-again{
      float: right;
      margin-top: 30px;
      width: 120px;
      height: 40px;
      background: #FFFFFF;
      border: 1px solid #DDDDDD;
      border-radius: 4px;
      margin-right: 30px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;

  }
   .order-button-again:hover{
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    opacity: 0.6;
    color: #287EFF;
}
  .order-button-again:focus{
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    color: #287EFF;
}
  .order-canle-time{
      display: inline-block;
      vertical-align: top;
      margin-left: -182px;
      margin-top: 60px;
  }
  .order-waitpay-img{
      position: absolute;
      margin-left: 30px;
      margin-top: -10px;
  }
  .order-waitpay-time{
    display: inline-block;
    vertical-align: top;
    margin-left: 50px;margin-top: -12px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FF620D;
    line-height: 20px;
  }
  .order-canle-font{
    display: inline-block;
    vertical-align: top;
    margin-top: -12px;
  }
  .order-gopay-button{
    position: absolute;
    margin-left: -125px;
    margin-top: -60px;
    width: 120px;
    height: 40px;
    background: rgb(40, 126, 255);
    border-radius: 4px;
    margin-right: 33px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    border: 0px solid #DCDFE6 !important;
  }
   .order-gopay-button:hover{background: #428EFF;}
   .order-gopay-button:active{background: #126BF0;}
   .order-gopay-button:focus{background: #126BF0;}
   .order-canle-button:hover{
      background: rgba(40, 126, 255, 0.1);
      border: 1px solid #287EFF;
      opacity: 0.6;
    }
   .order-canle-button:active {
background: rgba(40, 126, 255, 0.1);
border: 1px solid #287EFF;
border-radius: 4px;}
.order-canle-button:focus {
background: rgba(40, 126, 255, 0.1);
border: 1px solid #287EFF;
border-radius: 4px;}
  .order-canle-button{
      margin-top: -60px;
      margin-left: 10px;
      float: right;
      width: 120px;
      height: 40px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(221, 221, 221);
      border-radius: 4px;
      margin-right: 33px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
  }
  .order-shopInfo-font{
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 20px;
      vertical-align: top;
      margin-left: 30px ;
      margin-top: 30px;
      position: absolute;
  }
  .order-shopInfo-table{
      width: 920px;
      height: auto;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(238, 238, 238)!important;
      margin-left: 30px;
      float: left;
      margin-top: 70px;
  }
  .order-shopInfo-tr{
    height: 40px;
    background: #F6F6F6;
    text-align: center;
  }
  .order-shopInfo-content-tr{
      height: 110px;background: #FFFFFF;border: 1px solid #EEEEEE;
  }
  .order-shopInfo-name{
   /* margin: 25px;display: inline-block;vertical-align: top;cursor: pointer;
    margin-left: 0;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 22px;*/
      margin: 25px;
    margin-left: 20px;
    cursor: pointer;
    width: 256px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    text-overflow: -o-ellipsis-lastline;
    height: 22px;
    float: right;
    text-overflow: -o-ellipsis-lastline;
    line-height: 22px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off*/
      -webkit-box-orient:vertical;
     /* autoprefixer: on */
  }
  .order-shopInfo-name:hover{color: #287eff}
  .order-shopInfo-amount{
        text-align: center; height: 13px;font-size: 16px;font-family: PingFang SC;font-weight: bold;color: #FF620D;line-height: 20px;
  }
  .order-shopInfo-payType{
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 10px;
      margin-left: 30px;
     margin-top: 30px;

  }
  .order-shopInfo-actionType{
         margin-top: 20px;
    margin-left: 30px;
    width: 223px;
    height: 105px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
    display: inline;
    float: left;

  }
  .order-total-div{
    float: right;
    margin-right: 60px;
    margin-top: 0px;
  }
  .order-total-font{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
      margin-top: -5px;
      vertical-align: top;
  }
  .order-total-num{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgb(102, 102, 102);
    line-height: 20px;
    margin-right: 20px;
    vertical-align: top;
    margin-top: 5px;
    text-align: right;
    display: block;
  }
  .order-total-money{
      float: right;
      margin-right: -110px;
      margin-top: 60px;
      margin-bottom: 20px;
  }
  .order-total-money-font{
      height: 20px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
  }
  .order-total-totalAmount{
      height: 20px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FF620E;
      line-height: 20px;
  }
  // body {
  //   font-family: PingFang SC, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB, Microsoft Yahei, \\5FAE\8F6F\96C5\9ED1, STHeiti, \\534E\6587\7EC6\9ED1, sans-serif;
  //   color: #666;
  //   font-size: 14px;
  // }
  table,table tr th, table tr td { border:1px solid #EEEEEE; }
  .gray-sub-title {
    height: 38px;
    padding: 0 24px;
    background: #EEE;
    border-top: 1px solid #DBDBDB;
    border-bottom: 1px solid #DBDBDB;
    line-height: 38px;
    font-size: 12px;
    color: #666;
    display: flex;
    span {
      display: inline-block;
      height: 100%;
    }
    .first {
      display: flex;
      justify-content: space-between;
      flex: 1;
      .f-bc {
        > span {
          width: 112px;
          text-align: center;
        }
      }
    }
    .last {
      width: 230px;
      text-align: center;
      display: flex;
      border-left: 1px solid #ccc;
      span {
        flex: 1;
      }
    }
  }

  .bt {
    border-top: 1px solid #EFEFEF;
  }

  .date {
    padding-left: 0px;
  }

  .order-id {
    margin-left: 25px;
  }

  .cart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    &:hover {
      .del-order {
        display: block;
        background:#d1434a;
        padding:2px 6px;
        border-radius:6px;
        color:#fff;
        font-size:14px;
        margin-top:-3px;
      }
    }
    .del-order {
      display: none;
    }
    .cart-l {
      display: flex;
      align-items: center;
      flex: 1;
      padding: 15px 0;
      justify-content: space-between;
      position: relative;
      &:before {
        position: absolute;
        content: ' ';
        right: -1px;
        top: 0;
        width: 1px;
        background-color: #EFEFEF;
        height: 100%;
      }
      .ellipsis {
        margin-left: 20px;
        width: 220px;
      }
      .img-box {
        border: 1px solid #EBEBEB;
      }
      img {
        display: block;
        @include wh(80px);
      }
      .cart-l-r {
        display: flex;
        height:24px;
        line-height: 24px;
        > div {
          text-align: center;
          width: 112px;
        }
      }
      .car-l-l {
        display: flex;
        align-items: center;
      }
    }
    .cart-r {
      width: 230px;
      display: flex;
      span {
        text-align: center;
        flex: 1;
      }
    }
  }

  .prod-operation {
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 254px;
    .total{
      flex:0 0 100px;
      text-align: center;
      color:#d1434a;
    }
    .pay-content{
      flex:1;
      .payBtn {
        background:#20a0ff;
        padding:5px 10px;
        border-radius:6px;
        color:#fff;
        font-size:14px;
        margin: 0 auto;
      }
      .alreadyPay{
        font-size:14px;
        color:#999;
        text-align:center;
      }
    }
    div:last-child {
      padding-right: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// OrderDetails.vue?026152d6